<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">管理</el-breadcrumb-item>
      <el-breadcrumb-item>年级列表管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <el-row :gutter="20">
        <el-button @click="addUserDialogVisible = true" type="primary">添加</el-button>
      </el-row>
      <el-table :data="listData" border stripe>
        <el-table-column type="index" :index="indexMethod"></el-table-column>
        <el-table-column label="id" prop="id" align="center" width="50px"></el-table-column>
        <el-table-column label="班级名称" prop="name" align="center" width="140px"></el-table-column> 
        <el-table-column label="状态" align="center" width="140px">
          <template slot-scope="scope">
            <div class="status-cell">
              <span class="label">上架状态：</span>
              <el-tag size="mini" type="info" v-if="String(scope.row.status) === '0'">未上架</el-tag>
              <el-tag size="mini" type="success" v-else-if="String(scope.row.status) === '1'">已上架</el-tag>
              <el-tag size="mini" type="warning" v-else>未知</el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="创建时间" prop="create_time" align="center" width="150px"></el-table-column>
        <el-table-column label="更新时间" prop="update_time" align="center" width="150px"></el-table-column>

        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-tooltip :enterable="false" content="编辑" effect="dark" placement="top">
              <el-button @click="edit(scope.row.id)" icon="el-icon-edit" size="mini" type="primary"></el-button>
            </el-tooltip>
            <!-- <el-tooltip
              :enterable="false"
              content="删除"
              effect="dark"
              placement="top"
            >
              <el-button
                @click="deleteItem(scope.row.id)"
                icon="el-icon-delete"
                size="mini"
                type="danger"
              ></el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.page" :page-sizes="[10, 20, 30, 50]" :page-size="queryInfo.page_size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 添加对话框 -->
    <el-dialog :visible.sync="addUserDialogVisible" @close="addFormClose" title="添加" width="60%">
      <el-form :model="addForm" :rules="addFormRules" label-width="160px" ref="addFormRef">
        <el-form-item label="班级名称" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="上架状态" prop="status">
          <el-radio-group v-model="addForm.status">
            <el-radio :label="0">未上架</el-radio>
            <el-radio :label="1">已上架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span class="dialog-footer" slot="footer">
        <el-button @click="addUserDialogVisible = false">取 消</el-button>
        <el-button @click="addUser" type="primary">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑对话框 -->
    <el-dialog :visible.sync="editDialogVisible" @close="editFormClose" title="编辑" width="60%">
      <el-form :model="editForm" :rules="editFormRules" label-width="160px" ref="editFormRef">
        <el-form-item label="班级名称" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="上架状态" prop="status">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="0">未上架</el-radio>
            <el-radio :label="1">已上架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input v-model="editForm.create_time" disabled></el-input>
        </el-form-item>
        <el-form-item label="更新时间">
          <el-input v-model="editForm.update_time" disabled></el-input>
        </el-form-item>
      </el-form>

      <span class="dialog-footer" slot="footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button @click="sureToedit()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryInfo: {
        query: "",
        page: 1,
        page_size: 10,
      },  
      total: 0,
      listData: [],
      // 添加用户的对话框是否显示
      addUserDialogVisible: false,

      // 添加用户数据
      addForm: {
        name: "",
        status: "",
        update_time: "",
        create_time: "",
      },

      // 添加的表单校验
      addFormRules: {
        name: [{ required: true, message: "请输入班级名称", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },

      editForm: {
        id: "",
        name: "",
        status: "",
        update_time: "",
        create_time: "",
      },

      // 编辑用户弹框显示
      editDialogVisible: false,
      // 编辑用户的表单校验
      editFormRules: {
        name: [{ required: true, message: "请输入班级名称", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getList();
  },

  methods: {
    async getList() {
      const { data: res } = await this.$http.get("/admin/g/list", {
        params: this.queryInfo,
      });
      console.log(res.result);
      if (res.code != 200) return this.$message.error("获取数据失败");
      this.listData = res.result.items;
      // 兼容后端返回 total 或 count 字段
      this.total =
        res.result && (res.result.total !== undefined
          ? res.result.total
          : (res.result.count || 0));
    },

    // 表单关闭事件
    addFormClose() {
      console.log(this.$refs);
      this.$refs.addFormRef.resetFields();
      this.isshow = true;
    },

       handleSizeChange(newSize) {
      this.queryInfo.page_size = newSize
      this.getList()
    },

    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getList()
    },
    // 跨页连续索引显示
    indexMethod(index) {
      return (this.queryInfo.page - 1) * this.queryInfo.page_size + index + 1;
    },
    // 添加
    addUser() {
      // if (!this.dateValue) {
      //   return this.$message.error("请选择开始结束日期");
      // }

      this.addForm.vipStartDate = this.dateValue
        ? Date.parse(this.dateValue[0]) / 1000
        : null;
      this.addForm.vipEndDate = this.dateValue
        ? (Date.parse(this.dateValue[1]) + 24 * 60 * 60 * 1000 - 1) / 1000
        : null;
      this.addForm.vipActivateStartDate = this.addActivityEndDateValue
        ? Date.parse(this.addActivityEndDateValue[0]) / 1000
        : null;
      this.addForm.vipActivateEndDate = this.addActivityEndDateValue
        ? (Date.parse(this.addActivityEndDateValue[1]) +
          24 * 60 * 60 * 1000 -
          1) /
        1000
        : null;

      this.$refs.addFormRef.validate(async (field) => {
        if (!field) return;
        const { data: res } = await this.$http.post(
          "/admin/g/add",
          this.addForm
        );
        if (res.code != 200) {
          return this.$message.error("添加失败");
        }
        this.$message.success("添加成功");
        this.addUserDialogVisible = false;
        this.getList();
        this.isshow = true;
        this.addActivityEndDateValue = null;
        this.$refs.addFormRef.resetFields();
      });
    },

    // 编辑按钮点击
    async edit(userId) {
      const { data: res } = await this.$http.get("/admin/g/detail", {
        params: {
          id: userId,
        },
      });
      console.log(res);
      if (res.code != 200) {
        return this.$message.error("获取信息失败");
      }
      if (res.result.vipStartDate) {
        this.dateValue = [res.result.vipStartDate, res.result.vipEndDate];
      }
      if (res.result.vipActivateStartDate) {
        this.editActivityEndDateValue = [
          res.result.vipActivateStartDate,
          res.result.vipActivateEndDate,
        ];
      }
      this.editForm = res.result;
      this.editDialogVisible = true;
    },

    editFormClose() {
      this.editDialogVisible = false;
      this.dateValue = "";
    },

    // 编辑确认
    sureToedit() {
      console.log(this.dateValue);
      this.editForm.vipStartDate = this.dateValue
        ? Date.parse(this.dateValue[0]) / 1000
        : null;
      this.editForm.vipEndDate = this.dateValue
        ? (Date.parse(this.dateValue[1]) + 24 * 60 * 60 * 1000 - 1) / 1000
        : null;
      this.editForm.vipActivateStartDate = this.editActivityEndDateValue
        ? Date.parse(this.editActivityEndDateValue[0]) / 1000
        : null;
      this.editForm.vipActivateEndDate = this.editActivityEndDateValue
        ? (Date.parse(this.editActivityEndDateValue[1]) +
          24 * 60 * 60 * 1000 -
          1) /
        1000
        : null;

      this.$refs.editFormRef.validate(async (field) => {
        if (!field) return;
        const { data: res } = await this.$http.post(
          "/admin/g/edit",
          this.editForm
        );
        if (res.code != 200) {
          return this.$message.error("编辑失败");
        }
        this.$message.success("编辑成功");
        this.editDialogVisible = false;
        this.dateValue = "";
        this.getList();
      });
    },

    //  删除
    async deleteItem(id) {
      console.log(id);
      const result = await this.$confirm(
        "将永久删除该数据, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      console.log(result);
      if (result == "confirm") {
        const { data: res } = await this.$http.post("/admin/g/delete", {
          id: id,
        });
        if (res.code != 200) {
          return this.$message.error("删除失败");
        }
        this.$message.success("删除成功");
        this.getList();
      } else {
        return this.$message.info("删除已取消");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}

.status-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.status-cell .label {
  color: #606266;
}
</style>
